import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { SerializedStyles } from '@emotion/utils';
import { Grid, Typography } from '@material-ui/core';

import AddCircleIcon from 'assets/icons/addCircle';
import { ICustomTheme } from 'interfaces';
import { skipDisabledPropOption, getMainColor } from '../styles';

type Theme = {
  theme?: ICustomTheme;
};

export const cssMarginBottom = (theme: ICustomTheme): SerializedStyles =>
  css({
    marginBottom: theme.spacing(3),
  });

export const AllConditions = styled(Typography)<Theme>(({ theme }) => ({
  alignItems: 'center',
  color: theme.colors.white,
  cursor: 'pointer',
  display: 'flex',
  fontWeight: theme.typography.fontWeightBold,
  marginTop: theme.spacing(2),
  [theme.breakpoints.down('sm')]: {
    justifyContent: 'center',
  },
}));

export const SoloCondition = styled(Typography)<Theme>(({ theme }) => ({
  color: theme.colors.white,
  display: 'block',
  lineHeight: theme.typography.h4.lineHeight,
  [theme.breakpoints.down('sm')]: {
    textAlign: 'center',
  },
}));

export const Condition = styled(SoloCondition)<Theme>(({ theme }) => ({
  marginBottom: theme.spacing(1),
  '&:last-child': {
    marginBottom: theme.spacing(2),
  },
}));

export const ConditionsContainer = styled.div<{
  theme: ICustomTheme;
  maxHeight: number;
}>(({ theme, maxHeight }) => ({
  display: '-webkit-box',
  flexWrap: 'nowrap',
  maxHeight,
  overflow: 'hidden',
  '-webkit-box-orient': 'vertical',
  '-webkit-line-clamp': '4',
  '&:last-child': {
    marginBottom: -theme.spacing(2),
  },
}));

export const ConditionTitle = styled(
  Typography,
  skipDisabledPropOption,
)<{
  theme: ICustomTheme;
  isDisabled?: boolean;
}>(({ theme, isDisabled }) => ({
  color: getMainColor(theme, isDisabled),
  textAlign: 'left',
  paddingLeft: theme.spacing(4),
  marginBottom: theme.spacing(2),
  [theme.breakpoints.down('sm')]: {
    marginBottom: theme.spacing(1),
    textAlign: 'center',
    paddingLeft: 0,
  },
}));

export const ConditionsWrapper = styled(
  'div',
  skipDisabledPropOption,
)<{
  theme: ICustomTheme;
  isDisabled?: boolean;
}>(({ theme, isDisabled }) => ({
  backgroundColor: getMainColor(theme, isDisabled),
  padding: theme.spacing(5),
  textAlign: 'left',
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(3, 2),
  },
}));

export const ContactAdmin = styled.span<Theme>(({ theme }) => ({
  color: theme.colors.grey.dark,
  fontWeight: theme.typography.fontWeightLight,
  textTransform: 'lowercase',
}));

export const ConditionSubtitle = styled(Typography)<Theme>(({ theme }) => ({
  color: theme.colors.white,
  fontWeight: theme.typography.fontWeightBold,
  marginBottom: theme.spacing(1),
  [theme.breakpoints.down('sm')]: {
    textAlign: 'center',
  },
}));

export const GoalGrid = styled(Grid)<{
  theme: ICustomTheme;
  withStepper: boolean;
}>(({ theme, withStepper }) => ({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center',
  maxWidth: '100%',
  ...(withStepper
    ? {
        [theme.breakpoints.down('xs')]: {
          overflow: 'auto',
          '&::after': {
            background: `linear-gradient(to right, transparent, ${theme.colors.white})`,
            content: '""',
            height: 250,
            position: 'absolute',
            right: 0,
            top: theme.spacing(8),
            width: 90,
            zIndex: 1,
          },
        },
      }
    : {}),
}));

export const GoalNameValue = styled(Typography)<Theme>(({ theme }) => ({
  color: theme.colors.paletteFromBO.main,
  fontWeight: theme.typography.fontWeightBold,
  '&.disabled': {
    color: theme.colors.grey.main,
  },
}));

export const GoalUnit = styled(Typography)<Theme>(({ theme }) => ({
  color: theme.colors.grey.dark,
}));

export const GoalSubject = styled(Typography)<Theme>(({ theme }) => ({
  color: theme.colors.grey.dark,
}));

export const SeeMoreIcon = styled(AddCircleIcon)<Theme>(({ theme }) => ({
  fontSize: theme.typography.body1.fontSize,
  marginRight: theme.spacing(2),
}));
